import config from "../../config/config";
import { authFetch, buildAuthHeaders } from "./httpClient";
import { parseJson, buildApiError } from "../../features/visitor/api/apiHelpers";

const PERMISSIONS_ENDPOINTS = [
  `${config.BASE_URL}/permissions/me`,
  `${config.BASE_URL}/schedules/permissions/me`,
  `${config.BASE_URL}/visitors/permissions/me`,
];

async function fetchFromEndpoint(url) {
  const res = await authFetch(url, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  const htmlError =
    typeof data?.message === "string" &&
    data.message.includes("Server Error: An unexpected issue occurred");
  if (htmlError || res.status === 404) {
    return { ok: false, res, data };
  }
  if (!res.ok) {
    throw buildApiError(res, data, "Failed to load permissions");
  }
  return { ok: true, data: data?.data ?? data };
}

/** Submodule permissions for the logged-in role (User builder matrix). */
export async function fetchMyRolePermissions() {
  let lastError = null;

  for (const url of PERMISSIONS_ENDPOINTS) {
    try {
      const result = await fetchFromEndpoint(url);
      if (result.ok) {
        return result.data;
      }
    } catch (err) {
      lastError = err;
      if (err?.status === 401 || err?.message === "session_timeout") {
        throw err;
      }
    }
  }

  throw lastError || new Error("Failed to load permissions");
}
